<template>
  <div :class="setPosition ? '' : 'd-none'"
       ref="sticky"
       :style="freeCard ? 'position: absolute' + ' ; ' + 'left: ' + stickyNote.leftOffset + 'px; top: ' + stickyNote.topOffset + 'px;' : ''">
    <div :style="freeCard ? 'position: relative; height: 0px' : ''">
      <b-container
          @mousedown="onMouseDown"
          @mouseup="onMouseUp"
          ref="stickyContainer"
          :class="(freeCard ? 'sticky-note-free' : 'sticky-note') + ' p-0'"
          :style="'z-index: 100000; background: linear-gradient(315deg, ' + darkColorOfCard + ' 0%, ' + lightColorOfCard + ' 100%); ' +
          (stickyNote.isCollapsed && freeCard ? 'height: 32px; ' : 'height: 300px; ')"
      >
        <b-row class="no-gutters p-0 w-100" style="font-size: 16px">
          <b-col @click="pin" cols="1" class="p-0">
            <b-link data-test-path="pin-sticky-note" @mousedown.stop="" @mouseup.stop="">
              <font-awesome-layers full-width>
                <font-awesome-icon
                    icon="thumbtack"
                    class="fa-lg pl-2 pt-2"
                    style="color: #243C59;">
                </font-awesome-icon>
                <font-awesome-icon
                    v-if="stickyNote.isPinned"
                    icon="horizontal-rule"
                    class="fa-lg"
                    transform="down-2"
                    style="margin-left: 1px; left:0; top: 0; color: #243C59; transform: rotate(130deg);">
                </font-awesome-icon>
              </font-awesome-layers>
            </b-link>
          </b-col>
          <b-col cols="auto" class="p-0">
            <b-link @click="collapseStickyNoteCard" @mousedown.stop="" @mouseup.stop="">
              <font-awesome-icon
                  v-if="freeCard"
                  :icon="stickyNote.isCollapsed ? 'caret-square-down' : 'caret-square-up' "
                  class="fa-xl pl-2"
                  style="color: #243C59; padding-top: 2px">
              </font-awesome-icon>
            </b-link>
          </b-col>
          <b-col cols="8" class="pl-1">
            <b-link v-if="stickyNote.entityLabel && !stickyNote.businessEntityIsDeleted"
                    @click="moveToBusinessEntity"
                    class="mb-0"
                    style="color: black; -webkit-user-drag: none"
            >
              <span
                  class="collapse-area-sticky-note"
                  style="display: inline-block; width: 200px"
              >
                {{ stickyNote.formLabel }} : {{ stickyNote.entityLabel }}
              </span>
            </b-link>
            <s v-if="stickyNote.entityLabel && stickyNote.businessEntityIsDeleted"
               class="collapse-area-sticky-note"
               style="display: inline-block; width: 235px">
              {{ stickyNote.formLabel }} : {{ stickyNote.entityLabel }}
            </s>
            <p v-else-if="freeCard && stickyNote.isCollapsed && stickyNote.type.toString() === STANDARD"
                class="collapse-area-sticky-note mb-0">
              {{ text }}
            </p>
          </b-col>
          <b-col class="p-0 text-right">
            <b-link
                data-test-path="delete-sticky-note-button"
                @click="deleteStickyNote"
                @mousedown.stop="" @mouseup.stop=""
            >
              <font-awesome-icon
                  icon="trash"
                  class="fa-lg pr-2 pt-1"
                  style="color: #243C59;">
              </font-awesome-icon>
            </b-link>
          </b-col>
        </b-row>
        <b-row v-if="(freeCard && !stickyNote.isCollapsed) || !freeCard" class="no-gutters px-3 pb-3 pt-2">
          <b-col>
          <textarea
              :data-test-path="stickyNoteIndex !== null ? 'sticky-note-text-area[' +stickyNoteIndex +']' : 'sticky-note-text-area'"
              ref="textArea"
              class="area-sticky-note"
              maxlength="170"
              @focusout.stop="focusOut"
              @mousedown.stop="onMouseDown($event, false)"
              v-model="text"
          >
          </textarea>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>


import StickyNote from "@/server/com/silkplm/model/sticky/StickyNote";
import {BUSINESS_ENTITY, STANDARD} from "@/components/sticky/StickyNoteType";
import ActivityManager from "@/activity/ActivityManager";
import SampleActivity from "@/activity/samples/SampleActivity";
import FormsActions from "@/components/forms/FormsActions";
import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";

export default {
  name: "StickyNoteCard",

  created() {
    this.onMouseMove = (event) => {
      this.onMouseMoveImpl(event);
    };
  },


  async mounted() {
    this.$onUpdate(StickyNote, async (changeEvent) => {
      setTimeout(() => {
      }, 1000);
      if(changeEvent.tag === this.$tag()){
        return;
      }
      if (changeEvent.id === this.stickyNote.id) {
        this.stickyNote = changeEvent.instance;
        this.text = this.stickyNote.body;
        this.setColors();
      }
    });

    if (this.stickyNoteId) {
      this.stickyNote = await Rpc.StickyNotes.getStickyNote(this.stickyNoteId);
    }

    if (this.stickyNote) {
      this.text = this.stickyNote.body;
      this.setColors();
    }


    this.stickyElement = this.$refs.sticky;
    this.stickyContainer = this.$refs.stickyContainer;

    if (this.listOfStuckStickyNotes.length) {
      if (this.stickyNote.id && !this.stickyNote.leftOffset && !this.stickyNote.topOffset) {
        let stickyNote = _.find(this.listOfStuckStickyNotes, {id: this.stickyNote.id});
        if (stickyNote) {
          this.stickyNote.leftOffset = stickyNote.leftOffset;
          this.stickyNote.topOffset = stickyNote.topOffset;
        }
      }
    }
    this.setPosition = true;

    if (this.autofocus) {
      setTimeout(() => {
        this.$refs.textArea.focus()
      });
    }
    setTimeout(async () => {
      await this.sizeChanged();
    });

  },

  methods: {
    ignore() {

    },

    onMouseDown(event, preventClearTextArea) {
      if (this.dragged) {
        return;
      }

      if (this.freeCard) {
        this.dragged = true;
        if (this.$refs.textArea) {
          if (!preventClearTextArea) {
            if (this.stickyElement.offsetLeft < 0 || this.stickyElement.offsetTop < 0 ||
                this.stickyElement.offsetLeft + this.stickyElement.offsetWidth > window.innerWidth ||
                this.stickyElement.offsetTop + this.stickyElement.offsetHeight > window.innerHeight) {
              this.$refs.textArea.select();
              this.$refs.textArea.blur();
            }
          }
        }

        this.dragOffsetX = event.pageX - this.stickyElement.offsetLeft;
        this.dragOffsetY = event.pageY - this.stickyElement.offsetTop;

        this.moveAt(event.pageX, event.pageY);
        document.addEventListener('mousemove', this.onMouseMove);
      }
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    },

    onMouseUp() {
      this.stopTracking();
    },

    async collapseStickyNoteCard() {
      this.stickyNote.isCollapsed = !this.stickyNote.isCollapsed;
      this.stickyNote = await Rpc.StickyNotes.updateStickyNote(this.stickyNote).tag(this.$tag());;
    },

    stopTracking() {
      if (this.dragged) {
        this.dragged = false;

        document.removeEventListener('mousemove', this.onMouseMove);

        let leftPosition = this.stickyElement.offsetLeft;
        let topPosition = this.stickyElement.offsetTop;
        if (this.freeCard) {
          this.$emit("setPositionStickyNote", this.stickyNote, leftPosition, topPosition);
        }
      }
    },

    moveAt(pageX, pageY) {
      if (!this.stickyElement) {
        return;
      }

      const margin = 30;
      let newLeft = pageX - this.dragOffsetX;
      let newTop = pageY - this.dragOffsetY;

      const stickyWidth = this.stickyElement.offsetWidth;
      const stickyHeight = this.stickyElement.offsetHeight;

      // wyjscie za lewa krawedz
      if (newLeft + stickyWidth <= margin) {
        newLeft = margin - stickyWidth;
      }

      // wyjscie za prawa krawedz
      if (newLeft >= window.innerWidth - margin) {
        newLeft = window.innerWidth - margin;
      }
//
      // wyjscie za gorna
      if (newTop + stickyHeight <= margin) {
        newTop = margin - stickyHeight;
      }

      // wyjscie za dolna
      if (newTop >= window.innerHeight - margin) {
        newTop = window.innerHeight - margin;
      }

      this.stickyNote.leftOffset = newLeft;
      this.stickyNote.topOffset = newTop;
    },

    sizeChanged() {
      if (!this.stickyElement) {
        return;
      }

      let margin = 10;
      let stickyWidth = this.stickyContainer.offsetWidth + margin;
      let stickyHeight = this.stickyContainer.offsetHeight + margin;

      if (window.innerWidth < this.stickyElement.offsetLeft + stickyWidth) {
        this.stickyNote.leftOffset = window.innerWidth - stickyWidth;
      }
      if (window.innerHeight < this.stickyElement.offsetTop + stickyHeight) {
        this.stickyNote.topOffset = window.innerHeight - stickyHeight;
      }
    },

    onMouseMoveImpl(event) {
      if (!(event.buttons & 1)) {
        this.stopTracking();
      } else {
        this.moveAt(event.pageX, event.pageY);
      }
      event.stopPropagation();
      event.stopImmediatePropagation()
      return false;
    },


    async deleteStickyNote() {
      await Rpc.StickyNotes.deleteStickyNote(this.stickyNote.id);
    },

    async pin() {
      this.stickyNote.body = this.text;
      if (this.stickyNote.isPinned) {
        this.stickyNote = await Rpc.StickyNotes.unpinStickyNote(this.stickyNote).tag(this.$tag());
      } else {
        this.stickyNote = await Rpc.StickyNotes.pinStickyNote(this.stickyNote).tag(this.$tag());
      }
    },


    async focusOut() {
      this.stickyNote.body = this.text;
      this.stickyNote = await Rpc.StickyNotes.updateStickyNote(this.stickyNote).tag(this.$tag());
    },

    setColors() {
      if (this.stickyNote.type.toString() === STANDARD) {
        this.lightColorOfCard = "#fde910";
        this.darkColorOfCard = "#fefe33";
      } else if (this.stickyNote.type.toString() === BUSINESS_ENTITY) {
        this.lightColorOfCard = "#00bfff";
        this.darkColorOfCard = "#00ccff";
      }
    },

    async moveToBusinessEntity() {
      if (this.stickyNote.businessEntityId) {
        if (this.stickyNoteListVisible) {
          await FormsActions.editEntity(this.stickyNote.businessEntityClass, this.stickyNote.businessEntityId);
          EventBus.$emit(Events.showOrHideStickyNotesList);
        } else {
          await FormsActions.editEntity(this.stickyNote.businessEntityClass, this.stickyNote.businessEntityId);
        }
      }
    },

  },

  props: {
    stickyNoteId: {type: String, default: ""},
    stickyNoteIndex: {type: Number, default: null},
    stickyNoteListVisible: {type: Boolean, default: false},
    freeCard: {type: Boolean, default: false},
    listOfStuckStickyNotes: {
      type: Array, default() {
        return []
      }
    },
    autofocus: {type: Boolean, default: false},
    leftOffset: {type: Number, default: 0},
    topOffset: {type: Number, default: 0},
  },

  watch: {
    leftOffset: function (val) {
      this.stickyNote.leftOffset = val;
    },
    topOffset: function (val) {
      this.stickyNote.topOffset = val;
    },
  },

  data: () => ({
    lightColorOfCard: "",
    darkColorOfCard: "",
    text: "",
    dragOffsetX: 0,
    dragOffsetY: 0,
    stickyElement: null,
    stickyContainer: null,
    dragged: false,
    stickyNote: new StickyNote(),
    setPosition: false,
    STANDARD: STANDARD,
    BUSINESS_ENTITY: BUSINESS_ENTITY
  }),
}

</script>

<style scoped>
textarea {
  resize: none;
}

.sticky-note {
  width: 300px;
  height: 300px;
  display: inline-block;
  box-shadow: rgba(0, 0, 0, 0.16) 0 5px 20px 0, rgba(0, 0, 0, 0.06) 0 0 0 1px;
  z-index: 99999;
}

.sticky-note-free {
  position: absolute !important;
  cursor: grabbing;
  box-shadow: rgba(0, 0, 0, 0.16) 0 5px 20px 0, rgba(0, 0, 0, 0.06) 0 0 0 1px;
  width: 300px;
  display: inline-block;
  z-index: 1000;
}


.area-sticky-note {
  overflow: hidden;
  display: block;
  width: 100%;
  height: 240px;
  border: none;
  outline: none;
  background-color: transparent;

}

.collapse-area-sticky-note {
  overflow: hidden;
  margin-top: 5px;
  margin-left: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>